module.exports = __webpack_public_path__ + "img/COLLAR BW.b511834.svg";